var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.loading ? _c('div', {
    staticClass: "text-center py-2"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "secondary",
      "small": ""
    }
  })], 1) : _vm._l(_vm.pages, function (i) {
    return _c('pdf', {
      key: i,
      attrs: {
        "src": _vm.file,
        "page": i
      }
    });
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }